import React__default from 'react';
import { isEmpty } from 'lodash';
import { ContentfulPreviewContext } from '@invitae/nucleobase-engine-contentful';

var ContentfulPreviewProvider = function (_a) {
    var _b;
    var contentfulConfig = _a.contentfulConfig, children = _a.children;
    if (!contentfulConfig || isEmpty(contentfulConfig) || !(contentfulConfig === null || contentfulConfig === void 0 ? void 0 : contentfulConfig.enablePreview))
        return React__default.createElement(React__default.Fragment, null, children);
    return (React__default.createElement(ContentfulPreviewContext.Provider, { value: { shouldUsePreviewContext: (_b = contentfulConfig.enablePreview) !== null && _b !== void 0 ? _b : false } }, children));
};

export { ContentfulPreviewProvider as default };
//# sourceMappingURL=ContentfulPreviewProvider.esm.js.map
